import { useState, useEffect, useCallback } from 'react';
import { X } from 'lucide-react';
import { useUserPreferences } from '../../contexts/UserPreferencesContext';
import { useAuth } from '../../contexts/AuthContext';
import { getApiUrl } from '../../config/api';

// Liste complète des fuseaux horaires (doit correspondre à celle de Settings.tsx)
const timezoneOptions = [
  { value: '0', label: '(UTC+0) UTC' },
  { value: '-10', label: '(UTC-10) Honolulu' },
  { value: '-9', label: '(UTC-9) Ancrage' },
  { value: '-9b', label: '(UTC-9) Juneau' },
  { value: '-8', label: '(UTC-8) Los Angeles' },
  { value: '-8b', label: '(UTC-8) Vancouver' },
  { value: '-7', label: '(UTC-7) Denver' },
  { value: '-7b', label: '(UTC-7) Phoenix' },
  { value: '-6', label: '(UTC-6) Chicago' },
  { value: '-6b', label: '(UTC-6) San Salvador' },
  { value: '-6c', label: '(UTC-6) Ville de Mexico' },
  { value: '-5', label: '(UTC-5) Bogota' },
  { value: '-5b', label: '(UTC-5) Lima' },
  { value: '-5c', label: '(UTC-5) New York' },
  { value: '-5d', label: '(UTC-5) Toronto' },
  { value: '-4', label: '(UTC-4) Caracas' },
  { value: '-3', label: '(UTC-3) Buenos Aires' },
  { value: '-3b', label: '(UTC-3) Santiago' },
  { value: '-3c', label: '(UTC-3) São Paulo' },
  { value: '-1', label: '(UTC-1) Açores' },
  { value: '0b', label: '(UTC+0) Dublin' },
  { value: '0c', label: '(UTC+0) Lisbonne' },
  { value: '0d', label: '(UTC+0) Londres' },
  { value: '0e', label: '(UTC+0) Reykjavik' },
  { value: '1', label: '(UTC+1) Amsterdam' },
  { value: '1b', label: '(UTC+1) Belgrade' },
  { value: '1c', label: '(UTC+1) Berlin' },
  { value: '1d', label: '(UTC+1) Bratislava' },
  { value: '1e', label: '(UTC+1) Bruxelles' },
  { value: '1f', label: '(UTC+1) Budapest' },
  { value: '1g', label: '(UTC+1) Casablanca' },
  { value: '1h', label: '(UTC+1) Copenhague' },
  { value: '1i', label: '(UTC+1) Lagos' },
  { value: '1j', label: '(UTC+1) Luxembourg' },
  { value: '1k', label: '(UTC+1) Madrid' },
  { value: '1l', label: '(UTC+1) Malte' },
  { value: '1m', label: '(UTC+1) Oslo' },
  { value: '1n', label: '(UTC+1) Paris' },
  { value: '1o', label: '(UTC+1) Prague' },
  { value: '1p', label: '(UTC+1) Rome' },
  { value: '1q', label: '(UTC+1) Stockholm' },
  { value: '1r', label: '(UTC+1) Tunis' },
  { value: '1s', label: '(UTC+1) Varsovie' },
  { value: '1t', label: '(UTC+1) Vienne' },
  { value: '1u', label: '(UTC+1) Zurich' },
  { value: '2', label: '(UTC+2) Athènes' },
  { value: '2b', label: '(UTC+2) Bucarest' },
  { value: '2c', label: '(UTC+2) Helsinki' },
  { value: '2d', label: '(UTC+2) Jérusalem' },
  { value: '2e', label: '(UTC+2) Johannesburg' },
  { value: '2f', label: '(UTC+2) Le Caire' },
  { value: '2g', label: '(UTC+2) Nicosie' },
  { value: '2h', label: '(UTC+2) Riga' },
  { value: '2i', label: '(UTC+2) Tallinn' },
  { value: '2j', label: '(UTC+2) Vilnius' },
  { value: '3', label: '(UTC+3) Bahrein' },
  { value: '3b', label: '(UTC+3) Istanbul' },
  { value: '3c', label: '(UTC+3) Koweit' },
  { value: '3d', label: '(UTC+3) Moscou' },
  { value: '3e', label: '(UTC+3) Nairobi' },
  { value: '3f', label: '(UTC+3) Qatar' },
  { value: '3g', label: '(UTC+3) Riyadh' },
  { value: '3.5', label: '(UTC+3.5) Téhéran' },
  { value: '4', label: '(UTC+4) Dubaï' },
  { value: '4b', label: '(UTC+4) Muscat' },
  { value: '4.5', label: '(UTC+4.5) Kaboul' },
  { value: '5', label: '(UTC+5) Ashkhabad' },
  { value: '5b', label: '(UTC+5) Astana' },
  { value: '5c', label: '(UTC+5) Karachi' },
  { value: '5.5', label: '(UTC+5.5) Calcuta' },
  { value: '5.5b', label: '(UTC+5.5) Colombo' },
  { value: '5.75', label: '(UTC+5.75) Katmandou' },
  { value: '6', label: '(UTC+6) Dhaka' },
  { value: '6.5', label: '(UTC+6.5) Yangon' },
  { value: '7', label: '(UTC+7) Bangkok' },
  { value: '7b', label: '(UTC+7) Djakarta' },
  { value: '7c', label: '(UTC+7) Ho Chi Minh' },
  { value: '8', label: '(UTC+8) Chongqing' },
  { value: '8b', label: '(UTC+8) Hong Kong' },
  { value: '8c', label: '(UTC+8) Kuala Lumpur' },
  { value: '8d', label: '(UTC+8) Manille' },
  { value: '8e', label: '(UTC+8) Perth' },
  { value: '8f', label: '(UTC+8) Shanghai' },
  { value: '8g', label: '(UTC+8) Singapour' },
  { value: '8h', label: '(UTC+8) Taipei' },
  { value: '9', label: '(UTC+9) Séoul' },
  { value: '9b', label: '(UTC+9) Tokyo' },
  { value: '10', label: '(UTC+10) Brisbane' },
  { value: '10.5', label: '(UTC+10.5) Adélaïde' },
  { value: '11', label: '(UTC+11) Sydney' },
  { value: '12', label: '(UTC+12) Île Norfolk' },
  { value: '13', label: '(UTC+13) Nouvelle-Zélande' },
  { value: '13b', label: '(UTC+13) Tokelau' },
  { value: '13.75', label: '(UTC+13.75) Îles Chatham' },
];

// Correspondance IANA timezone → valeur de l'option (gère DST automatiquement)
const IANA_TO_APP_VALUE: Record<string, string> = {
  'UTC': '0', 'Etc/UTC': '0', 'Etc/GMT': '0',
  'Pacific/Honolulu': '-10', 'America/Adak': '-10',
  'America/Anchorage': '-9', 'America/Nome': '-9',
  'America/Juneau': '-9b', 'America/Sitka': '-9b', 'America/Yakutat': '-9b',
  'America/Los_Angeles': '-8', 'America/Tijuana': '-8',
  'America/Vancouver': '-8b',
  'America/Denver': '-7', 'America/Boise': '-7',
  'America/Phoenix': '-7b',
  'America/Chicago': '-6', 'America/Matamoros': '-6', 'America/Winnipeg': '-6',
  'America/El_Salvador': '-6b', 'America/Guatemala': '-6b', 'America/Managua': '-6b', 'America/Costa_Rica': '-6b', 'America/Tegucigalpa': '-6b',
  'America/Mexico_City': '-6c', 'America/Monterrey': '-6c', 'America/Merida': '-6c',
  'America/Bogota': '-5', 'America/Guayaquil': '-5', 'America/Panama': '-5',
  'America/Lima': '-5b',
  'America/New_York': '-5c', 'America/Detroit': '-5c', 'America/Indiana/Indianapolis': '-5c',
  'America/Toronto': '-5d',
  'America/Caracas': '-4',
  'America/Halifax': '-4', 'America/Manaus': '-4', 'America/Barbados': '-4', 'America/Puerto_Rico': '-4',
  'America/Argentina/Buenos_Aires': '-3', 'America/Argentina/Cordoba': '-3', 'America/Montevideo': '-3',
  'America/Santiago': '-3b',
  'America/Sao_Paulo': '-3c', 'America/Fortaleza': '-3c', 'America/Recife': '-3c',
  'Atlantic/Azores': '-1',
  'Europe/Dublin': '0b',
  'Europe/Lisbon': '0c',
  'Europe/London': '0d',
  'Atlantic/Reykjavik': '0e', 'Africa/Abidjan': '0e', 'Africa/Accra': '0e',
  'Europe/Amsterdam': '1',
  'Europe/Belgrade': '1b', 'Europe/Ljubljana': '1b', 'Europe/Sarajevo': '1b', 'Europe/Skopje': '1b', 'Europe/Zagreb': '1b',
  'Europe/Berlin': '1c',
  'Europe/Bratislava': '1d',
  'Europe/Brussels': '1e',
  'Europe/Budapest': '1f',
  'Africa/Casablanca': '1g',
  'Europe/Copenhagen': '1h',
  'Africa/Lagos': '1i', 'Africa/Kinshasa': '1i', 'Africa/Brazzaville': '1i', 'Africa/Bangui': '1i', 'Africa/Douala': '1i', 'Africa/Libreville': '1i', 'Africa/Luanda': '1i', 'Africa/Malabo': '1i', 'Africa/Ndjamena': '1i', 'Africa/Niamey': '1i',
  'Europe/Luxembourg': '1j',
  'Europe/Madrid': '1k', 'Africa/Ceuta': '1k',
  'Europe/Malta': '1l',
  'Europe/Oslo': '1m',
  'Europe/Paris': '1n', 'Europe/Monaco': '1n',
  'Europe/Prague': '1o',
  'Europe/Rome': '1p', 'Europe/Vatican': '1p', 'Europe/San_Marino': '1p',
  'Europe/Stockholm': '1q',
  'Africa/Tunis': '1r',
  'Europe/Warsaw': '1s',
  'Europe/Vienna': '1t',
  'Europe/Zurich': '1u', 'Europe/Vaduz': '1u', 'Europe/Busingen': '1c',
  'Europe/Athens': '2', 'Europe/Kyiv': '2', 'Europe/Kiev': '2',
  'Europe/Bucharest': '2b', 'Europe/Sofia': '2b', 'Europe/Chisinau': '2b',
  'Europe/Helsinki': '2c', 'Europe/Mariehamn': '2c',
  'Asia/Jerusalem': '2d', 'Asia/Tel_Aviv': '2d',
  'Africa/Johannesburg': '2e', 'Africa/Harare': '2e', 'Africa/Gaborone': '2e', 'Africa/Lusaka': '2e', 'Africa/Maputo': '2e',
  'Africa/Cairo': '2f',
  'Asia/Nicosia': '2g', 'Asia/Famagusta': '2g',
  'Europe/Riga': '2h',
  'Europe/Tallinn': '2i',
  'Europe/Vilnius': '2j',
  'Asia/Bahrain': '3',
  'Europe/Istanbul': '3b',
  'Asia/Kuwait': '3c',
  'Europe/Moscow': '3d', 'Europe/Simferopol': '3d',
  'Africa/Nairobi': '3e', 'Africa/Dar_es_Salaam': '3e', 'Africa/Addis_Ababa': '3e', 'Africa/Kampala': '3e', 'Africa/Mogadishu': '3e',
  'Asia/Qatar': '3f',
  'Asia/Riyadh': '3g', 'Asia/Aden': '3g',
  'Asia/Tehran': '3.5',
  'Asia/Dubai': '4', 'Asia/Tbilisi': '4', 'Asia/Yerevan': '4',
  'Asia/Muscat': '4b',
  'Asia/Kabul': '4.5',
  'Asia/Tashkent': '5', 'Asia/Ashgabat': '5', 'Asia/Samarkand': '5',
  'Asia/Almaty': '5b', 'Asia/Bishkek': '5b',
  'Asia/Karachi': '5c',
  'Asia/Calcutta': '5.5', 'Asia/Kolkata': '5.5',
  'Asia/Colombo': '5.5b',
  'Asia/Katmandu': '5.75', 'Asia/Kathmandu': '5.75',
  'Asia/Dhaka': '6', 'Asia/Thimphu': '6',
  'Asia/Rangoon': '6.5', 'Asia/Yangon': '6.5',
  'Asia/Bangkok': '7', 'Asia/Phnom_Penh': '7', 'Asia/Vientiane': '7',
  'Asia/Jakarta': '7b', 'Asia/Pontianak': '7b',
  'Asia/Ho_Chi_Minh': '7c', 'Asia/Saigon': '7c',
  'Asia/Chongqing': '8', 'Asia/Harbin': '8', 'Asia/Urumqi': '8', 'Asia/Ulaanbaatar': '8',
  'Asia/Shanghai': '8f',
  'Asia/Hong_Kong': '8b',
  'Asia/Kuala_Lumpur': '8c', 'Asia/Kuching': '8c',
  'Asia/Manila': '8d',
  'Australia/Perth': '8e',
  'Asia/Singapore': '8g',
  'Asia/Taipei': '8h',
  'Asia/Seoul': '9',
  'Asia/Tokyo': '9b',
  'Australia/Brisbane': '10', 'Pacific/Port_Moresby': '10',
  'Australia/Adelaide': '10.5', 'Australia/Broken_Hill': '10.5',
  'Australia/Sydney': '11', 'Australia/Melbourne': '11', 'Australia/Hobart': '11', 'Pacific/Guadalcanal': '11', 'Pacific/Noumea': '11',
  'Pacific/Norfolk': '12',
  'Pacific/Auckland': '13', 'Pacific/Fiji': '12',
  'Pacific/Fakaofo': '13b',
  'Pacific/Chatham': '13.75',
};

// Map inverse: app value → premier fuseau IANA correspondant
const APP_VALUE_TO_IANA: Record<string, string> = {};
for (const [iana, appVal] of Object.entries(IANA_TO_APP_VALUE)) {
  if (!(appVal in APP_VALUE_TO_IANA)) {
    APP_VALUE_TO_IANA[appVal] = iana;
  }
}

// Retourne l'offset UTC courant (DST inclus) pour un fuseau IANA donné
function getCurrentOffsetForIana(ianaName: string): number {
  try {
    const parts = Intl.DateTimeFormat('en', {
      timeZone: ianaName,
      timeZoneName: 'shortOffset'
    }).formatToParts(new Date());
    const tzName = parts.find(p => p.type === 'timeZoneName')?.value || '';
    const match = tzName.match(/GMT([+-])(\d+)(?::(\d+))?/);
    if (match) {
      const sign = match[1] === '+' ? 1 : -1;
      return sign * (parseInt(match[2]) + parseInt(match[3] || '0') / 60);
    }
    if (tzName === 'GMT') return 0;
  } catch {}
  return -new Date().getTimezoneOffset() / 60;
}

// Détecte le fuseau horaire précis via IANA (gère DST automatiquement)
function detectTimezoneAppValue(): { appValue: string; ianaName: string; offset: number } {
  const ianaName = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const offset = -new Date().getTimezoneOffset() / 60;
  const appValue = IANA_TO_APP_VALUE[ianaName] || String(offset);
  return { appValue, ianaName, offset };
}

export const TimezoneChangeModal = () => {
  const { user } = useAuth();
  const { preferences, updatePreferences, loading: prefsLoading } = useUserPreferences();
  const [showModal, setShowModal] = useState(false);
  const [detectedTimezone, setDetectedTimezone] = useState<string>('');
  const [detectedTimezoneLabel, setDetectedTimezoneLabel] = useState<string>('');
  const [lastCheckedTimezone, setLastCheckedTimezone] = useState<string | null>(null);
  const [hasShownInitialModal, setHasShownInitialModal] = useState(false);

  // Fonction pour vérifier le fuseau horaire
  const checkTimezone = useCallback(() => {
    if (!user || prefsLoading || !preferences || showModal) return;
    
    const savedTimezone = preferences.globalTimezone;
    
    // Détecter via IANA pour une précision parfaite (DST compris)
    const { appValue: detectedAppValue, ianaName, offset: deviceOffset } = detectTimezoneAppValue();
    
    // CAS 1: L'utilisateur n'a pas de fuseau horaire sauvegardé (nouvel utilisateur)
    if (!savedTimezone) {
      if (hasShownInitialModal) return;
      
      updatePreferences({
        globalTimezone: detectedAppValue,
        declinedTimezoneChanges: []
      });
      
      if (user) {
        user.getIdToken().then(token => {
          fetch(getApiUrl(`/api/sync-timezones/${user.uid}`), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ globalTimezone: detectedAppValue })
          }).catch(console.error);
        }).catch(console.error);
      }
      
      setHasShownInitialModal(true);
      return;
    }
    
    // CAS 2: L'utilisateur a déjà un fuseau horaire sauvegardé
    // Éviter de revérifier le même fuseau IANA
    if (lastCheckedTimezone === ianaName) return;
    
    const declinedTimezones = preferences.declinedTimezoneChanges || [];
    
    // Comparer la valeur précise (IANA-based) avec la valeur sauvegardée
    if (detectedAppValue !== savedTimezone) {
      // Ne pas déclencher si l'offset courant réel est identique (ex: Berlin vs Paris en heure d'été, les deux à UTC+2)
      const savedIana = APP_VALUE_TO_IANA[savedTimezone];
      const savedCurrentOffset = savedIana ? getCurrentOffsetForIana(savedIana) : parseFloat(savedTimezone.replace(/[a-z]/gi, ''));
      const sameCurrentOffset = Math.abs(deviceOffset - savedCurrentOffset) < 0.01;

      if (!sameCurrentOffset) {
        // Vérifier si l'utilisateur a déjà refusé ce changement (compat ancienne/nouvelle format)
        const alreadyDeclined = declinedTimezones.includes(ianaName) || declinedTimezones.includes(detectedAppValue);
        if (!alreadyDeclined) {
          // Construire le label avec l'offset COURANT réel (pas l'offset standard)
          const matchingOption = timezoneOptions.find(opt => opt.value === detectedAppValue);
          const cityName = matchingOption?.label.replace(/^\(UTC[^\)]+\)\s*/, '') || ianaName;
          const sign = deviceOffset >= 0 ? '+' : '';
          const label = `(UTC${sign}${deviceOffset}) ${cityName}`;
          
          setDetectedTimezone(detectedAppValue);
          setDetectedTimezoneLabel(label);
          setShowModal(true);
        }
      }
    }
    
    setLastCheckedTimezone(ianaName);
  }, [user, preferences, prefsLoading, showModal, lastCheckedTimezone, hasShownInitialModal]);

  // Vérifier au chargement initial
  useEffect(() => {
    checkTimezone();
  }, [checkTimezone]);

  // Écouter quand l'utilisateur revient sur l'onglet
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // Réinitialiser pour permettre une nouvelle vérification
        setLastCheckedTimezone(null);
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Écouter les changements de focus de la fenêtre (pour les cas où visibilitychange ne fonctionne pas)
  useEffect(() => {
    const handleFocus = () => {
      // Réinitialiser pour permettre une nouvelle vérification
      setLastCheckedTimezone(null);
    };

    window.addEventListener('focus', handleFocus);
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, []);

  // Accepter le changement de fuseau horaire
  const handleAcceptTimezoneChange = async () => {
    // detectedTimezone contient désormais directement la valeur de l'option (ex: '1n')
    const matchingOption = timezoneOptions.find(opt => opt.value === detectedTimezone);
    
    if (matchingOption) {
      await updatePreferences({
        globalTimezone: matchingOption.value,
        declinedTimezoneChanges: []
      });
      
      if (user) {
        try {
          const token = await user.getIdToken();
          await fetch(getApiUrl(`/api/sync-timezones/${user.uid}`), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ globalTimezone: matchingOption.value })
          });
        } catch (error) {
          console.error('Erreur sync timezone:', error);
        }
      }
    }
    setShowModal(false);
  };

  // Refuser le changement de fuseau horaire (mode change)
  const handleRejectTimezoneChange = async () => {
    const ianaName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const currentDeclined = preferences?.declinedTimezoneChanges || [];
    if (!currentDeclined.includes(ianaName)) {
      await updatePreferences({
        declinedTimezoneChanges: [...currentDeclined, ianaName]
      });
    }
    setShowModal(false);
  };

  if (!showModal) return null;

  // MODE CHANGE: Changement de fuseau horaire détecté
  return (
    <>
      {/* Version Desktop - Modal centré */}
      <div className="hidden sm:flex fixed inset-0 bg-black/50 z-[100] items-center justify-center" onClick={handleRejectTimezoneChange}>
        <div 
          className="bg-surface rounded-xl shadow-xl max-w-md w-full mx-4 overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4">
            <h2 className="text-lg font-semibold text-content-primary">Fuseau horaire</h2>
            <button
              onClick={handleRejectTimezoneChange}
              className="p-2 transition-opacity hover:opacity-70"
            >
              <X className="h-5 w-5 text-content-secondary" />
            </button>
          </div>
          
          <div className="p-6 pt-0 space-y-4">
            <p className="text-content-secondary">
              Nous avons détecté que le fuseau horaire de votre appareil a changé.
            </p>
            <p className="text-content-primary font-medium text-center text-lg">{detectedTimezoneLabel}</p>
            <p className="text-sm text-content-secondary">
              Voulez-vous mettre à jour votre fuseau horaire dans l'application ?
            </p>
            
            <div className="flex gap-3 pt-2">
              <button
                onClick={handleRejectTimezoneChange}
                className="bento-button-secondary flex-1"
              >
                Conserver l'actuel
              </button>
              <button
                onClick={handleAcceptTimezoneChange}
                className="bento-button flex-1"
              >
                Mettre à jour
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Version Mobile - BottomSheet */}
      <div className="sm:hidden fixed inset-0 bg-black/50 z-[100] flex items-end" onClick={handleRejectTimezoneChange}>
        <div 
          className="bg-surface w-full rounded-t-xl max-h-[85vh] overflow-hidden flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4">
            <h2 className="text-lg font-semibold text-content-primary">Fuseau horaire</h2>
            <button
              onClick={handleRejectTimezoneChange}
              className="p-2 transition-opacity hover:opacity-70"
            >
              <X className="h-5 w-5 text-content-secondary" />
            </button>
          </div>
          
          {/* Content */}
          <div className="p-4 pt-0 space-y-4">
            <p className="text-content-secondary">
              Nous avons détecté que le fuseau horaire de votre appareil a changé.
            </p>
            <p className="text-content-primary font-medium text-center text-lg">{detectedTimezoneLabel}</p>
            <p className="text-sm text-content-secondary">
              Voulez-vous mettre à jour votre fuseau horaire dans l'application ?
            </p>
            
            <div className="flex flex-col items-center gap-3 pt-2 pb-4">
              <button
                onClick={handleAcceptTimezoneChange}
                className="bento-button w-1/2"
              >
                Mettre à jour
              </button>
              <button
                onClick={handleRejectTimezoneChange}
                className="bento-button-secondary w-1/2"
              >
                Conserver l'actuel
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
